import styled from 'styled-components';

const FormSectionStyle = styled.div`
	--landingBlockMaxWidth: var(--sp86x);
	--landingBlockMTop: var(--sp25x);
	--landingBlockTitleMarginBottom: var(--sp5x);
	--landingBlockSubtitleMarginBottom: var(--sp5x);
	--landingBlockSuccessPanelSizes: var(--sp7x);
	--landingBlockSuccessPanelMarginRight: var(--sp4x);
	--landingBlockSuccessIconSize: var(--sp3x);

	--landingBlockCheckboxWrapMarginTop: var(--sp6x);
	--landingBlockCheckboxSize: var(--sp3x);
	--landingBlockCheckboxMarginRight: var(--sp2x);
	--landingBlockCheckIconSize: var(--sp1-5x);

	--customColPadding: var(--sp2x);

	.landing-form-block {
		max-width: var(--landingBlockMaxWidth);
		margin: 0 auto var(--landingBlockMTop);
		text-align: center;

		.landing-form-title {
			margin-bottom: var(--landingBlockTitleMarginBottom);
		}

		.landing-form-subtitle {
			margin-bottom: var(--landingBlockSubtitleMarginBottom);
		}

		.global-error {
			margin-bottom: var(--landingBlockSubtitleMarginBottom);
		}

		.landing-form-form {
			.container {
				--colPadding: var(--customColPadding);
			}

			.landing-form-btn {
				display: inline-flex;
				justify-content: flex-end;
				align-self: flex-end;
				margin-top: var(--landingBlockCheckboxWrapMarginTop);

				> button {
					padding: 0;
				}
			}

			textarea {
				resize: none;
			}

			.ant-input-textarea-suffix {
				display: none;
			}
		}
	}

	.success-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: calc(var(--landingBlockMTop) / 4) 0;
		background-color: var(--secondaryColor1);
		/* text-align: left; */

		.success-panel {
			display: flex;
			justify-content: center;
			align-items: center;
			min-width: var(--landingBlockSuccessPanelSizes);
			min-height: var(--landingBlockSuccessPanelSizes);
			background-color: var(--successColor);
			margin-right: var(--landingBlockSuccessPanelMarginRight);
			clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);

			.success-icon {
				color: var(--primaryColor3);
				font-size: var(--landingBlockSuccessIconSize);
			}
		}
	}

	.checkbox-warp {
		width: fit-content;
		display: flex;
		align-items: center;
		cursor: pointer;

		.checkbox {
			display: flex;
			justify-content: center;
			align-items: center;
			width: var(--landingBlockCheckboxSize);
			height: var(--landingBlockCheckboxSize);
			margin-right: var(--landingBlockCheckboxMarginRight);
			border: 1px solid black;
			border-radius: var(--sp0-5x);
			cursor: pointer;

			.check-icon {
				font-size: var(--landingBlockCheckIconSize);
			}

			&.active {
				border: 1px solid var(--primaryColor2);
				background-color: var(--primaryColor2);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--landingBlockMaxWidth: var(--sp64x);
		--landingBlockMTop: var(--sp20x);
		--landingBlockTitleMarginBottom: var(--sp4x);
		--landingBlockSubtitleMarginBottom: var(--sp5x);
		--landingBlockSuccessPanelSizes: var(--sp7x);
		--landingBlockSuccessPanelMarginRight: var(--sp3x);
		--landingBlockSuccessIconSize: var(--sp3x);

		--landingBlockCheckboxWrapMarginTop: var(--sp5x);
		--landingBlockCheckboxSize: var(--sp3x);
		--landingBlockCheckboxMarginRight: var(--sp2x);
		--landingBlockCheckIconSize: var(--sp1-5x);

		--customColPadding: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--landingBlockMaxWidth: var(--sp50x);
		--landingBlockMTop: var(--sp20x);
		--landingBlockTitleMarginBottom: var(--sp3x);
		--landingBlockSubtitleMarginBottom: var(--sp5x);
		--landingBlockSuccessPanelSizes: var(--sp5x);
		--landingBlockSuccessPanelMarginRight: var(--sp3x);
		--landingBlockSuccessIconSize: var(--sp2x);

		--landingBlockCheckboxWrapMarginTop: var(--sp3x);
		--landingBlockCheckboxSize: var(--sp3x);
		--landingBlockCheckboxMarginRight: var(--sp2x);
		--landingBlockCheckIconSize: var(--sp1-5x);

		--customColPadding: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--landingBlockMaxWidth: var(--sp48x);
		--landingBlockMTop: var(--sp10x);
		--landingBlockTitleMarginBottom: var(--sp3x);
		--landingBlockSubtitleMarginBottom: var(--sp4x);
		--landingBlockSuccessPanelSizes: var(--sp5x);
		--landingBlockSuccessPanelMarginRight: var(--sp3x);
		--landingBlockSuccessIconSize: var(--sp2x);

		--landingBlockCheckboxWrapMarginTop: var(--sp3x);
		--landingBlockCheckboxSize: var(--sp3x);
		--landingBlockCheckboxMarginRight: var(--sp1x);
		--landingBlockCheckIconSize: var(--sp1-5x);

		--customColPadding: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--landingBlockMaxWidth: var(--sp51x);
		--landingBlockMTop: var(--sp10x);
		--landingBlockTitleMarginBottom: var(--sp3x);
		--landingBlockSubtitleMarginBottom: var(--sp4x);
		--landingBlockSuccessPanelSizes: var(--sp5x);
		--landingBlockSuccessPanelMarginRight: var(--sp3x);
		--landingBlockSuccessIconSize: var(--sp2x);

		--landingBlockCheckboxWrapMarginTop: var(--sp3x);
		--landingBlockCheckboxSize: var(--sp3x);
		--landingBlockCheckboxMarginRight: var(--sp1x);
		--landingBlockCheckIconSize: var(--sp1-5x);

		--customColPadding: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--landingBlockMaxWidth: var(--sp44x);
		--landingBlockMTop: var(--sp10x);
		--landingBlockTitleMarginBottom: var(--sp3x);
		--landingBlockSubtitleMarginBottom: var(--sp4x);
		--landingBlockSuccessPanelSizes: var(--sp5x);
		--landingBlockSuccessPanelMarginRight: var(--sp2x);
		--landingBlockSuccessIconSize: var(--sp2x);

		--landingBlockCheckboxWrapMarginTop: var(--sp3x);
		--landingBlockCheckboxSize: var(--sp3x);
		--landingBlockCheckboxMarginRight: var(--sp1x);
		--landingBlockCheckIconSize: var(--sp1-5x);

		--customColPadding: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--landingBlockMaxWidth: var(--sp64x);
		--landingBlockMTop: var(--sp10x);
		--landingBlockTitleMarginBottom: var(--sp3x);
		--landingBlockSubtitleMarginBottom: var(--sp4x);
		--landingBlockSuccessPanelSizes: var(--sp5x);
		--landingBlockSuccessPanelMarginRight: var(--sp2x);
		--landingBlockSuccessIconSize: var(--sp2x);

		--landingBlockCheckboxWrapMarginTop: var(--sp3x);
		--landingBlockCheckboxSize: var(--sp3x);
		--landingBlockCheckboxMarginRight: var(--sp1x);
		--landingBlockCheckIconSize: var(--sp1-5x);

		--customColPadding: var(--sp1x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--landingBlockMaxWidth: 100%;
		--landingBlockMTop: var(--sp10x);
		--landingBlockTitleMarginBottom: var(--sp3x);
		--landingBlockSubtitleMarginBottom: var(--sp4x);
		--landingBlockSuccessPanelSizes: var(--sp5x);
		--landingBlockSuccessPanelMarginRight: var(--sp2x);
		--landingBlockSuccessIconSize: var(--sp2x);

		--landingBlockCheckboxWrapMarginTop: var(--sp3x);
		--landingBlockCheckboxSize: var(--sp2x);
		--landingBlockCheckboxMarginRight: var(--sp1x);
		--landingBlockCheckIconSize: var(--sp1x);
	}
`;

export default FormSectionStyle;
